<div class="header-bar">
  <div class="tmn-logo" (click)="goToHome()">
    <img src="assets/images/logo-bpi.svg" class="logo-bpi" alt="logo-bpi">
    <span class="title">Track Ma Notif</span>
  </div>
  <div class="button-container">
    <tmn-header-bar-button [teamsCampaignVisible]="teamsCampaignVisible" [thresholdsVisible]="thresholdsVisible"
    ></tmn-header-bar-button>
  </div>
</div>


